export default __webpack_public_path__ + "static/media/NewLogo.d9f3445b.jpg";